import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ArrayHelper } from 'apps/idl/src/helpers';
import { EPrefix, IContact } from 'apps/idl/src/model';
import { IPatient } from 'apps/idl/src/modules/patients/model/IPatient';
import { PatientsService } from 'apps/idl/src/modules/patients/services/patients.service';
import { ContactsService } from 'apps/idl/src/services/security';
import { map, tap } from 'rxjs/operators';
import { PanneauService } from '../../../services/panneau.service';

@Component({
  selector: 'di-panneau-choix-contact',
  templateUrl: './panneau-choix-contact.component.html',
  styleUrls: ['./panneau-choix-contact.component.scss'],
})
export class PanneauChoixContactComponent implements OnInit {

  @Input() patient?: IPatient;
	@Input() contact?: IContact;



  public model: IPatient;
	public showListContact : boolean;
	public contacts : IContact[] = [];


  constructor(
    private svcPanneau: PanneauService,
    private svcPatients: PatientsService,
		private svcContacts : ContactsService,
    private router: Router) { }

		ngOnInit() {
			this.model = this.patient;
			if (this.contact) {
					this.initFormContact();
			} else {
				this.initListContact();
			}
		}	
	
	

	private initListContact() {
		this.showListContact = true;
		this.svcContacts.getSiteContactsAnakin([], EPrefix.contact, true, false, true).pipe(
			map((contacts: IContact[]): IContact[] => {
				return contacts.map((contact: IContact) => {
					if (!contact.isDoctor && contact.finess) {
						contact.isDoctor = true;
					}
					return contact;
				});
			}),
			tap((contactsList: IContact[]) => {
				if (ArrayHelper.hasElements(contactsList))
					this.contacts = contactsList;
			})
		).subscribe();
	}

	private initFormContact () {
		this.showListContact = false;
	}

  public udpdateContact(contactId: string) {
    const existingContacts: string[] = this.patient.contacts || [];
    const isDuplicate = existingContacts.includes(contactId);
    let listContact: string[];
    if (!isDuplicate) {
        listContact = [
            ...existingContacts,
            contactId
        ];
    } else {
        listContact = existingContacts;
    }
    this.model = {
        ...this.model,
        contacts: listContact
    };
    this.svcPatients.savePatientAnakin(this.model).subscribe(() => {
        this.svcPanneau.close();
    });
	}

	public updatePatient = () => {
		this.svcPanneau.close();
	}

  public handleClickAddContact() {
		this.svcPanneau.close();
		this.router.navigate(["contacts", "add"], { state: { route: ['patients', this.model._id], context: 'patient_contact', patient: this.model } });
	}

	public handleCancelContact = () => {
		this.svcPanneau.close();
	}

  public handleClickAddContactOnMobile() {
    this.svcPanneau.close();
  }
}
